"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABI_LOAN = void 0;
exports.ABI_LOAN = [
    {
        type: 'function',
        name: 'LIQUIDATE_LOAN_COLLATERAL_CATEGORY',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'bytes32',
                internalType: 'bytes32',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'REPAY_INTERESTS_CATEGORY',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'bytes32',
                internalType: 'bytes32',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'acceptApr',
        inputs: [],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'aprUpdatedOn',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'borrower',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'address',
                internalType: 'address',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'borrowerCommitment',
        inputs: [],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'callLoan',
        inputs: [
            {
                name: 'callbackPeriodInSeconds',
                type: 'uint256',
                internalType: 'uint256',
            },
            {
                name: 'gracePeriodInSeconds',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'callbackDeadline',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'canSeizeCollateral',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'bool',
                internalType: 'bool',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'changeLateFees',
        inputs: [
            {
                name: 'lateInterestFeeWithTwoDecimals',
                type: 'uint256',
                internalType: 'uint256',
            },
            {
                name: 'latePrincipalFeeWithTwoDecimals',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'changeMaintenanceCollateralRatio',
        inputs: [
            {
                name: 'newRatioWith2Decimals',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'changeOracle',
        inputs: [
            {
                name: 'newOracleAddr',
                type: 'address',
                internalType: 'address',
            },
        ],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'claimCollateral',
        inputs: [],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'collateralAmountSeized',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'collateralToken',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'address',
                internalType: 'address',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'currentApr',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'cycleInterestsRepaid',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'deployedBy',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'address',
                internalType: 'address',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'effectiveLoanAmount',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'expiryInfo',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'feesCollector',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'address',
                internalType: 'address',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'feesOracle',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'address',
                internalType: 'address',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'fromTokenToToken',
        inputs: [
            {
                name: 'principalPrice',
                type: 'uint256',
                internalType: 'uint256',
            },
            {
                name: 'principalQty',
                type: 'uint256',
                internalType: 'uint256',
            },
            {
                name: 'collateralPrice',
                type: 'uint256',
                internalType: 'uint256',
            },
            {
                name: 'collateralDecimals',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'pure',
    },
    {
        type: 'function',
        name: 'fundLoan',
        inputs: [],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'fundedOn',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'fundingDeadline',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'fundingPeriod',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'getCollateralRequirements',
        inputs: [],
        outputs: [
            {
                name: 'initialCollateralAmount',
                type: 'uint256',
                internalType: 'uint256',
            },
            {
                name: 'maintenanceCollateralAmount',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'getDebt',
        inputs: [],
        outputs: [
            {
                name: 'currentBillingCycle',
                type: 'uint256',
                internalType: 'uint256',
            },
            {
                name: 'cyclesSinceLastAprUpdate',
                type: 'uint256',
                internalType: 'uint256',
            },
            {
                name: 'interestOwed',
                type: 'uint256',
                internalType: 'uint256',
            },
            {
                name: 'applicableLateFee',
                type: 'uint256',
                internalType: 'uint256',
            },
            {
                name: 'minPaymentAmount',
                type: 'uint256',
                internalType: 'uint256',
            },
            {
                name: 'maxPaymentAmount',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'getNextPaymentDate',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'getUpcomingAmountAfterFees',
        inputs: [
            {
                name: 'paymentAmount',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        outputs: [
            {
                name: 'upcomingPaymentAmountAfterFees',
                type: 'uint256',
                internalType: 'uint256',
            },
            {
                name: 'upcomingNetDebtAfterFees',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'initialCollateralRatio',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'lateInterestFee',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'latePrincipalFee',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'lender',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'address',
                internalType: 'address',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'liquidate',
        inputs: [],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'loanAmountInPrincipalTokens',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'loanState',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint8',
                internalType: 'uint8',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'loanTypeInfo',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'string',
                internalType: 'string',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'maintenanceCollateralRatio',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'manager',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'address',
                internalType: 'address',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'minInterestAmount',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'paymentIntervalInSeconds',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'priceOracle',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'address',
                internalType: 'address',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'principalAmount',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'principalRepaid',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'principalToken',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'address',
                internalType: 'address',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'proposeNewApr',
        inputs: [
            {
                name: 'newAprWithTwoDecimals',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'proposedApr',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'repay',
        inputs: [
            {
                name: 'paymentAmount',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'repayInterests',
        inputs: [],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'repayPrincipal',
        inputs: [
            {
                name: 'paymentAmountInTokens',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'returnCollateral',
        inputs: [
            {
                name: 'depositAmount',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'seizeCollateral',
        inputs: [
            {
                name: 'amount',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'setFeesCollector',
        inputs: [
            {
                name: 'newFeesCollector',
                type: 'address',
                internalType: 'address',
            },
        ],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'setFeesOracle',
        inputs: [
            {
                name: 'newFeesOracle',
                type: 'address',
                internalType: 'address',
            },
        ],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'function',
        name: 'totalInterestPaymentFees',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'totalInterestRepaid',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'uint256',
                internalType: 'uint256',
            },
        ],
        stateMutability: 'view',
    },
    {
        type: 'function',
        name: 'updateInfo',
        inputs: [
            {
                name: 'newExpiryInfo',
                type: 'uint256',
                internalType: 'uint256',
            },
            {
                name: 'newLoanTypeInfo',
                type: 'string',
                internalType: 'string',
            },
        ],
        outputs: [],
        stateMutability: 'nonpayable',
    },
    {
        type: 'event',
        name: 'OnAprAcceptedByBorrower',
        inputs: [
            {
                name: 'oldApr',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
            {
                name: 'newApr',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
        ],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnBorrowerCommitment',
        inputs: [],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnBorrowerWithdrawal',
        inputs: [
            {
                name: 'numberOfTokens',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
        ],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnCollateralCaptured',
        inputs: [
            {
                name: 'amount',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
        ],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnCollateralClaimed',
        inputs: [
            {
                name: 'collateralClaimed',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
        ],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnCollateralRatioChanged',
        inputs: [
            {
                name: 'prevValue',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
            {
                name: 'newValue',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
        ],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnCollateralRedeposited',
        inputs: [
            {
                name: 'depositAmount',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
        ],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnFeeProcessed',
        inputs: [
            {
                name: 'feePercent',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
            {
                name: 'feeAmount',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
            {
                name: 'from',
                type: 'address',
                indexed: false,
                internalType: 'address',
            },
            {
                name: 'to',
                type: 'address',
                indexed: false,
                internalType: 'address',
            },
        ],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnInterestsRepayment',
        inputs: [
            {
                name: 'paymentAmountTokens',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
        ],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnLateFeesChanged',
        inputs: [
            {
                name: 'prevLateInterestFee',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
            {
                name: 'newLateInterestFee',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
            {
                name: 'prevLatePrincipalFee',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
            {
                name: 'newLatePrincipalFee',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
        ],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnLoanCalled',
        inputs: [
            {
                name: 'callbackPeriodInHours',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
            {
                name: 'gracePeriodInHours',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
        ],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnLoanClosed',
        inputs: [],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnLoanFunded',
        inputs: [
            {
                name: 'amount',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
        ],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnLoanMatured',
        inputs: [],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnNewAprProposed',
        inputs: [
            {
                name: 'oldApr',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
            {
                name: 'newApr',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
        ],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnPriceOracleChanged',
        inputs: [
            {
                name: 'prevAddress',
                type: 'address',
                indexed: false,
                internalType: 'address',
            },
            {
                name: 'newAddress',
                type: 'address',
                indexed: false,
                internalType: 'address',
            },
        ],
        anonymous: false,
    },
    {
        type: 'event',
        name: 'OnPrincipalRepayment',
        inputs: [
            {
                name: 'paymentAmountTokens',
                type: 'uint256',
                indexed: false,
                internalType: 'uint256',
            },
        ],
        anonymous: false,
    },
];
//# sourceMappingURL=Loan.js.map